import React, { useEffect, useState } from "react";
import { CourseDetail } from "../../../typings/course";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../UI/Tabs";
import TabContentAbout from "../../../pages/course/partials/tab-content-about";
import TabContentMaterial from "../../../pages/course/partials/tab-content-material";

const CourseTabs: React.FC<{ course: CourseDetail }> = ({ course }) => {
  const [tabActive, setTabActive] = useState<string>("about");
  useEffect(() => {
    if (course) {
      if (course?.isJoined) {
        setTabActive("activity");
      }
    }
  }, [course]);
  return (
    <Tabs
      value={tabActive}
      onValueChange={(c) => {
        setTabActive(c);
      }}
    >
      <TabsList color="indigo">
        <TabsTrigger value="about">Tentang</TabsTrigger>
        <TabsTrigger value="activity">Materi</TabsTrigger>
        <TabsTrigger value="live-session">Sesi Langsung</TabsTrigger>
      </TabsList>
      <TabsContent value="about">
        {course && <TabContentAbout course={course} />}
      </TabsContent>
      <TabsContent value="activity">
        {course && (
          <TabContentMaterial activities={course.activities} course={course} />
        )}
      </TabsContent>
      <TabsContent value="live-session">Belum Ada</TabsContent>
    </Tabs>
  );
};
export default CourseTabs;